export default __webpack_public_path__ + "static/media/icon_android.c9fca14b.png";